import React, { useState, useRef, useEffect } from "react"
import { Document, Page, pdfjs } from "react-pdf"
import { Button, Flex, Spin } from "antd"
import "react-pdf/dist/esm/Page/AnnotationLayer.css"
import "react-pdf/dist/esm/Page/TextLayer.css"

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`

const PdfViewer = ({ url, height = 400 }) => {
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [containerWidth, setContainerWidth] = useState(null)
  const containerRef = useRef(null)

  useEffect(() => {
    if (!containerRef.current) return
    const observer = new ResizeObserver((entries) => {
      if (entries[0]) setContainerWidth(entries[0].contentRect.width)
    })
    observer.observe(containerRef.current)
    setContainerWidth(containerRef.current.getBoundingClientRect().width)
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    setPageNumber(1)
    setNumPages(null)
  }, [url])

  return (
    <div ref={containerRef} style={{ height, overflowY: "auto" }}>
      <Document
        file={url}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        loading={
          <Flex justify="center" align="center" style={{ minHeight: 100 }}>
            <Spin />
          </Flex>
        }
        error={
          <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
            Unable to display PDF preview. Please download the file to view it.
          </div>
        }
      >
        {containerWidth && (
          <Page
            pageNumber={pageNumber}
            width={containerWidth}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        )}
      </Document>
      {numPages > 1 && (
        <Flex justify="center" align="center" gap={12} style={{ padding: "8px 0" }}>
          <Button size="small" onClick={() => setPageNumber((p) => p - 1)} disabled={pageNumber <= 1}>
            Prev
          </Button>
          <span style={{ fontSize: 13 }}>
            {pageNumber} / {numPages}
          </span>
          <Button size="small" onClick={() => setPageNumber((p) => p + 1)} disabled={pageNumber >= numPages}>
            Next
          </Button>
        </Flex>
      )}
    </div>
  )
}

export default PdfViewer
